module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "bgCharactersModuleTwo"
  }, [_c('texter', {
    attrs: {
      "data": _vm.texterData
    }
  }), _vm._v(" "), _c('dylan', {
    attrs: {
      "data": _vm.dylanData
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(0, 50)"
    }
  }, [_c('boyFour', {
    attrs: {
      "data": _vm.boyFourData
    }
  }), _vm._v(" "), _c('girlFour', {
    attrs: {
      "data": _vm.girlFourData
    }
  }), _vm._v(" "), _c('boyThree', {
    attrs: {
      "data": _vm.boyThreeData
    }
  }), _vm._v(" "), _c('girlThree', {
    attrs: {
      "data": _vm.girlThreeData
    }
  }), _vm._v(" "), _c('girlTwo', {
    attrs: {
      "data": _vm.girlTwoData
    }
  }), _vm._v(" "), _c('boyTwo', {
    attrs: {
      "data": _vm.boyTwoData
    }
  })], 1), _vm._v(" "), _c('boyOne', {
    attrs: {
      "data": _vm.boyOneData
    }
  }), _vm._v(" "), _c('girlOne', {
    attrs: {
      "data": _vm.girlOneData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ad0d144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/backgroundCharacters.vue
// module id = 678
// module chunks = 1